import type { Map as MapboxMap, MapboxGeoJSONFeature } from 'mapbox-gl';

// Only the two methods the box query needs, so callers can pass the raw
// react-map-gl map without a getMap() return-type mismatch.
type HitTestMap = Pick<MapboxMap, 'getLayer' | 'queryRenderedFeatures'>;

// Query the layers rendered under a small box around a screen point. Dots and
// centroids are only a few pixels wide, so an exact-point hit-test would almost
// never land on one. Shared by the well-click and document-hover popups.
export const queryFeaturesNear = (
  map: HitTestMap,
  point: { x: number; y: number },
  layerIds: string[],
  pad = 4
): MapboxGeoJSONFeature[] => {
  const layers = layerIds.filter((id) => map.getLayer(id));
  if (!layers.length) return [];
  const box: [[number, number], [number, number]] = [
    [point.x - pad, point.y - pad],
    [point.x + pad, point.y + pad],
  ];
  return map.queryRenderedFeatures(box, { layers });
};
